import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import Service from "../../services/bodyParams";
import "react-datepicker/dist/react-datepicker.css";

type Props = {
  updateData: () => void; // Funkcja do odświeżania danych
};

const PostBirthDate: React.FC<Props> = ({ updateData }) => {
  const { t } = useTranslation("global");
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  // rzutowanie DatePicker, obejście błędu typów TS
  const DatePickerComponent = DatePicker as unknown as React.ComponentType<any>;

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (selectedDate) {
      Service.postBirthDate(selectedDate)
        .then(() => {
          console.log("Wysłano datę:", selectedDate);
          updateData(); // Odśwież dane po pomyślnym wysłaniu
        })
        .catch((error) => {
          console.error("Błąd podczas wysyłania daty:", error);
        });
    } else {
      console.log("Wybierz datę urodzenia.");
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div style={{ display: "flex", alignItems: "center", gap: "1em" }}>
          <label>{t("buttons.select_birthdate")}:</label>
          <DatePickerComponent
            selected={selectedDate}
            onChange={(date: Date | null) => setSelectedDate(date)}
            dateFormat="yyyy-MM-dd"
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={100} // Możliwość wyboru 100 lat wstecz
          />
        </div>
        <button type="submit" className="field">{t("buttons.add")}</button>
      </form>
    </div>
  );
};

export default PostBirthDate;
